import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import ProgressBar from "./ProgressBar";
import PersonalInfo from "./PersonalInfo";
import Motivational from "./Motivational";
import SocialMedia from "./SocialMedia";
import Preview from "./Preview";
import "../assets/css/multiple.css";
import { useDispatch, useSelector } from "react-redux";
import { updateFormValues, resetFormValues } from "../redux/reducer";
import { Box, Button } from "@mui/material";
import MultipleFormModal from "./MultipleFormModal";
import Youtube from "./Youtube";
import axios from "axios";

const MultipleForm = () => {
  const dispatch = useDispatch();
  const formValues = useSelector((state) => state.form.formValues);

  //to get submition status
  const [modalStatus, setModalStatus] = useState({
    active: false,
    isSuccessfull: false,
    message: "",
  });

  const formik = useFormik({
    initialValues: formValues,
    validationSchema: Yup.object({
      full_name: Yup.string().required("Required"),
      email: Yup.string().email("invalid email").required("Required"),
      motivation: Yup.string()
        .max(150, "Must be less than 150 characters")
        .required("Required"),
      occupation: Yup.string().required("Required"),
      course_title: Yup.string().required("Required"),
      phone: Yup.string().required("Required"),
      x_post_link: Yup.string().required("Required"),
      linkedin_post_link: Yup.string().required("Required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
      
        const response = await axios.post("https://nexatrux.com/backend/public/api/submit-application", values);
  
        if (response.status === 200) {
          dispatch(resetFormValues());
          resetForm();

          setModalStatus({
            ...modalStatus,
            active: true,
            isSuccessfull: true,
            message: "Your details have been sent",
          });
          setTimeout(() => {
            setModalStatus({
              ...modalStatus,
              active: false,
            });
            setCurrentStep(0);
          }, 4000);
        }
      } catch (error) {
        console.error("Error submitting application:", error);
        setModalStatus({
          ...modalStatus,
          active: true,
          isSuccessfull: false,
          message: "Something went wrong. Please try again later.",
        });
        setTimeout(() => {
          setModalStatus({
            ...modalStatus,
            active: false,
          });
        }, 4000);
      }
    },
  });
  const [currentStep, setCurrentStep] = useState(0);
  const steps = [
    <PersonalInfo formik={formik} />,
    <Motivational formik={formik} />,
    <SocialMedia formik={formik} />,
    <Preview
      formik={formik}
      currentStep={currentStep}
      setCurrentStep={setCurrentStep}
    />,
  ];

  const next = () => {
    dispatch(updateFormValues(formik.values));
    if (currentStep === 0) {
      if (
        formik.errors.first_name ||
        formik.errors.email ||
        formik.errors.phone ||
        formik.errors.occupation ||
        formik.errors.course_title
      ) {
        setCurrentStep(currentStep);
      } else {
        setCurrentStep(currentStep + 1);
      }
    } else if (currentStep === 1) {
      if (formik.errors.motivation) {
        setCurrentStep(currentStep);
      } else {
        setCurrentStep(currentStep + 1);
      }
    } else if (currentStep === 2) {
      if (formik.errors.x_post_link || formik.errors.linkedin_post_link) {
        setCurrentStep(currentStep);
      } else {
        setCurrentStep(currentStep + 1);
      }
    } else if (currentStep === steps.length - 1) {
      setCurrentStep((currentStep) => currentStep + 1);
    }
  };

  const back = () => {
    setCurrentStep((currentStep) =>
      currentStep > 0 ? currentStep - 1 : currentStep
    );
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          WebkitTransition: "1s ease-in-out",
          Transition: "1s ease-in-out",
          color: "var(--color-blue_2)",
        }}
      >
        <ProgressBar
          steps={steps}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
        />

        <form onSubmit={formik.handleSubmit} className="multiple-form">
          {steps[currentStep]}
          
          
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "20px",
              marginTop: "20px",
            }}
          >
            {currentStep > 0 ? (
              <Button variant="contained" type="button" onClick={back}>
                Back
              </Button>
            ) : (
              ""
            )}

            {currentStep <= steps.length - 1 ? (
              <Button variant="contained" type="button" onClick={() => next()}>
                Save & Continue
              </Button>
            ) : (
              <Button variant="contained" type="submit">
                Finish
              </Button>
            )}
          </Box>
        </form>
        {modalStatus.active ? (
            <MultipleFormModal modalStatus={modalStatus} />
          ) : null}
        {currentStep === 2 ? <Youtube /> : null}
      </Box>
    </>
  );
};

export default MultipleForm;
